<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li v-if="privacypolicylData.acf?.title"><router-link to="/privacypolicy">{{ privacypolicylData.acf?.title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="cms">
      <div class="container">
        <div class="cms-cont">
          <h2 v-if="privacypolicylData.acf?.title && !isLoading">{{ privacypolicylData.acf?.title }}</h2>
          <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 39px;">
            <PuSkeleton style="height: 30px;" :count="1"/>
          </div>
          <div v-if="privacypolicylData.acf?.html_text && !isLoading" class="cms-cont__top" v-html="privacypolicylData.acf?.html_text"></div>
          <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 46px;">
            <PuSkeleton style="height: 15px;" :count="25"/>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RouterLink } from 'vue-router';
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: 'PrivatePolicy',
  components: {},
  data() {
    return {
      privacypolicylData: {},
      isLoading: true,
    }
  },
  computed: {
  },
  methods: {
  },
  created() {
    this.isLoading = true;
    getUrl(`/others_privacypolicy/${process.env.VUE_APP_ID_PRIVATEPOLICY}`)
    .then((response) => {
      this.privacypolicylData = response.data;

      metaData(
        `${this.privacypolicylData.acf?.title ? this.privacypolicylData.acf?.title : 'サイトのご利用について'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGの個人情報保護方針についてのご案内ページです。',
        'HARUMIFLAGタウンポータル',
        'article'
      )
      
      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    });
  },
}
</script>